export * from './students.component';
export * from './register//register.component';
export * from './new-entry/new-entry.component';
